// Explain saved execution facts only. Current rules, phase membership and type
// configuration are deliberately not inputs to a historical explanation.
const text = value => typeof value === 'string' && value.trim() ? value.trim() : null;
const typeLabel = type => text(type?.label) || text(type?.singular);
const plural = count => count === 1 ? 'response' : 'responses';

function periodLabel(rule) {
  const unit = { day: 'day', daily: 'day', week: 'week', weekly: 'week',
    month: 'month', monthly: 'month', term: 'school term', quarter: 'school quarter',
    year: 'school year', yearly: 'school year' }[rule.timeframe];
  if (!unit) return 'the configured period';
  const count = Number.isInteger(rule.timeCount) && rule.timeCount > 0 ? rule.timeCount : 1;
  return `${count} ${unit}${count === 1 ? '' : 's'}`;
}

export function getBehaviourResponseExplanation(event) {
  const record = event?.originalData || event;
  const receipt = record?.escalationPersistence;
  if (!record?.autoGenerated || receipt?.version !== 1 || receipt.phasePolicy?.enabled !== true ||
    !Array.isArray(receipt.steps)) return null;
  const context = record.phaseContext;
  const phase = context?.status === 'known'
    ? `Phase at recording: ${text(context.phaseName) || 'Recorded phase'}`
    : context?.status === 'unassigned' ? 'No assigned phase at recording.'
      : 'The phase at recording could not be determined.';
  const initialRule = text(record.ruleName)
    ? { id: text(record.triggeredByRule), name: record.ruleName } : null;
  const steps = receipt.steps.map((step, index) => {
    const rule = step.rule || {};
    const from = typeLabel(step.inputType) || typeLabel(receipt.steps[index - 1]?.outputType) ||
      (index === 0 ? 'Initial response' : 'Previous response');
    const to = typeLabel(step.outputType) || 'Next response';
    const threshold = Number.isFinite(rule.threshold) && rule.threshold >= 0 ? rule.threshold : null;
    const count = Number.isFinite(step.matchedCount) && step.matchedCount >= 0 ? step.matchedCount : null;
    const selected = Array.isArray(step.sourceIds) ? step.sourceIds.length : 0;
    return {
      key: `${index}:${step.ruleId || ''}`,
      ruleId: text(step.ruleId), ruleName: text(rule.title) || 'Escalation rule',
      transition: `${from} → ${to}`,
      condition: threshold === null ? 'The saved escalation condition was met.'
        : threshold === 0 ? 'Applies to the next response.'
          : `Threshold: ${threshold} earlier ${plural(threshold)} in ${periodLabel(rule)}.`,
      count: count === null ? null : `${count} qualifying earlier ${plural(count)} found.`,
      reset: selected === 0 ? null : step.resetAfterUse
        ? `${selected} counted ${plural(selected)} marked as used by this escalation.`
        : `${selected} counted ${plural(selected)} left available after this escalation.`,
    };
  });
  return { phase, initialRule, steps };
}
